import { Lock } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export const ConfidentialityDisclaimer = () => {
  const { t } = useLanguage();
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex items-start gap-3 mb-6">
      <Lock className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
      <div>
        <p className="text-sm text-blue-700 font-medium mb-1">{t("footprints.confidentialityDisclaimerTitle")}</p>
        <p className="text-xs text-blue-600">{t("footprints.confidentialityDisclaimerDescription")}</p>
      </div>
    </div>
  );
}
